import React from 'react'
import Loader from 'react-loader-spinner'
export default function LoadingAnimation() {
  return (
    <>
    <Loader type="Puff" color="#00BFFF" height={60} width={60} style={{margin:"50vh auto"}} className='pc-loader' />
    </>
  )
}
